function NewQuery(searchTerm, currentPage, labelsPerPage) {
  return {
    "query": {
      "function_score": {
        "query": {
          "bool": {
            "should": [
              {
                "match": {
                  "label.ngram": {
                    "query": searchTerm,
                    "boost": 10,
                    "_name": "ngram search * score_multiply_10"
                  }
                }
              },
              {
                "multi_match": {
                  "query": searchTerm,
                  "fields": [
                    "label.ngram_transform1",
                    "label.ngram_transform2"
                  ],
                  "boost": 10,
                  "_name": "transform ngram search * score_multiply_10"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.second_char_transform1",
                          "label.second_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1",
                          "label.third_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 10,
                  "_name": "G and transform(E) and transform(O) and RGE * score_multiply_10"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char_transform1",
                          "label.first_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.second_char_transform1",
                          "label.second_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1",
                          "label.third_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 10,
                  "_name": "transform(G) and transform(E) and transform(O) and RGE * score_multiply_10"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 6,
                  "_name": "G and RGE * score_multiply_6"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.second_char_transform1",
                          "label.second_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1",
                          "label.third_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_2_chars_drop_last_keep_first_two"
                        ]
                      }
                    }
                  ],
                  "boost": 8,
                  "_name": "G and transform(E) and transform(O) and GE? * score_multiply_8"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1",
                          "label.third_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.fourth_char_transform1",
                          "label.fourth_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_2_chars_drop_last_keep_first_two"
                        ]
                      }
                    }
                  ],
                  "boost": 8,
                  "_name": "G and transform(O) and transform(R) and GE? * score_multiply_8"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "match": {
                        "label.first_char": searchTerm
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_2_chars_drop_last_keep_first_two"
                        ]
                      }
                    }
                  ],
                  "boost": 3,
                  "_name": "G and GE? * score_multiply_3"
                }
              }
            ],
            "filter": [
              {
                "term": {
                  "available": "true"
                }
              }
            ],
            "minimum_should_match": 1
          }
        },
        "functions": [
          {
            "filter": {
              "term": {
                "supplier_id": "19"
              }
            },
            "weight": 2
          }
        ],
        "score_mode": "multiply",
        "boost_mode": "multiply"
      }
    },
    "size": labelsPerPage,
    "from": (currentPage - 1) * labelsPerPage,
    "track_total_hits": true
  };
}
export default NewQuery;
